<template>
    <div v-click-outside="blur">
        <vx-input
            ref="input"
            v-bind="$attrs"
            disable-chrome-autocomplete
            :value="displayText"
            icon-pack="feather"
            icon="icon-calendar"
            :label="label"
            :class="[{ active: focused }]"
            class="w-full"
            @focus="onInputFocused"
            @input="checkForClear"
            @keydown.tab.shift="blur"
            @keydown.tab.exact="blur"
            color="primary"
            :hide-state-icons="showDaysWarning"
            :description-text="showDaysWarning && daysFromDate >= 7 ? daysFromDateText : ''"
            :danger-text="showDaysWarning ? daysFromDateText : ''"
            :danger="showDaysWarning && localValue && daysFromDate < 7"
        />
        <div
            v-show="focused"
            class="calendar"
            @keydown.enter.prevent="tabNext"
            @keydown.tab.shift.prevent="tabBack"
            @keydown.tab.exact.prevent="tabNext"
        >
            <calendar
                v-bind="$attrs"
                v-on="$listeners"
                ref="calendar"
                transition="slide-h"
                :attributes="localCalendarAttributes"
                :disabled-dates="disabledDates"
                :is-dark="theme.theme == 'dark'"
                @dayclick="selectDate"
            >
                <template slot="day-popover" slot-scope="attrs">
                    <slot name="day-popover" v-bind="attrs"></slot>
                </template>
            </calendar>
        </div>
    </div>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd'
import ClickOutside from 'vue-click-outside'
import { mapGetters } from 'vuex'

export default {
    name: 'vx-calendar-input',
    components: {
        Calendar
    },
    props: {
        value: {
            type: [Date, String]
        },
        label: {
            type: String
        },
        color: {
            Type: String
        },
        attributes: {
            type: Array,
            default: () => []
        },
        disabledDates: {
            type: Array
        },
        showDaysWarning: {
            type: Boolean,
            default: false
        },
        highlightCurrentDate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            focused: false,
            valid: false
        }
    },
    watch: {
        focused(val) {
            this.input.isFocus = val
        },
        disabledDates(newv, oldv) {
            if (this.label == 'Expiry Date') {
                // debugger
            }
        }
    },
    computed: {
        ...mapGetters({
            theme: 'user/theme'
        }),
        localAttrs() {
            return {
                ...this.$attrs
            }
        },
        highlightCurrentDateAttribute() {
            return {
                key: 'today',
                bar: {
                    color: 'red'
                },
                dates: new Date()
            }
        },
        daysFromDate() {
            if (this.localValue) {
                return this.localValue.daysFromNow()
            }
            return null
        },
        daysFromDateText() {
            if (!this.localValue) {
                return ''
            } else if (this.localValue.isToday()) {
                return 'Today'
            } else if (this.daysFromDate < 0) {
                return `${Math.abs(this.daysFromDate)} Days Ago`
            }
            return `${this.daysFromDate} Days Away`
        },
        displayText() {
            if (this.localValue) {
                return this.localValue.toDateString()
            }
        },
        selectedDateAtttribute() {
            return {
                key: 'selected',
                highlight: 'blue',
                dates: this.localValue
            }
        },
        localCalendarAttributes() {
            var attributes = [...this.attributes, this.selectedDateAtttribute]

            if (this.highlightCurrentDate) {
                attributes.push(this.highlightCurrentDateAttribute)
            }
            return attributes
        },
        localValue: {
            get() {
                return this.value && new Date(this.value)
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        calendar() {
            return this.$refs.calendar
        },
        input() {
            return this.$refs.input
        }
    },
    methods: {
        checkForClear(v) {
            if (v === null) {
                this.localValue = null
            }
        },
        clearSelection() {
            this.localValue = null
        },
        blur(e) {
            this.focused = false
        },
        onInputFocused(e) {
            this.focused = true
            this.$nextTick(() => {
                if (this.localValue) {
                    this.$refs.calendar.focusDate(this.localValue)
                } else {
                    this.$refs.calendar.focusDate(new Date())
                }
            })
        },
        async selectDate(val) {
            if (val.isDisabled) {
                return
            }
            this.localValue = val.date
            this.blur()
            this.$nextTick(async () => {
                await this.input.$validator.validate()
            })
        },
        tabNext(e) {
            this.blur()
            this.$nextTick(() => {
                var next = this.$refs.input.$el.nextFormField()
                if (next) {
                    next.focus()
                }
            })
        },
        tabBack(e) {
            this.blur()
            this.$nextTick(() => {
                var prev = this.$refs.input.$el.previousFormField()
                if (prev) {
                    prev.focus()
                }
            })
        }
    },
    directives: {
        ClickOutside
    }
}
</script>

<style scoped>
.calendar {
    position: absolute;
    z-index: 500000;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    margin-top: 4px;
}

.vs-input.active ::v-deep label {
    color: rgba(var(--vs-primary), 1);
}

.vs-input.active ::v-deep input {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}

.vs-input.active ::v-deep i {
    color: rgba(var(--vs-primary), 1);
}
</style>
